<template>
  <v-dialog max-width="800" v-on="$listeners" v-bind="$attrs">
    <v-card>
      <v-card-title>
        {{ $t("people.affiliates.affiliate-networks") }}
        <v-btn icon class="close-button" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="programSales"
          :loading="loadingSale"
          :no-data-text="$t('common.no-results-found')"
          :loading-text="$t('common.searching-info')"
          :footer-props="{
            itemsPerPageOptions: [10],
            itemsPerPageText: $t('sales.items_per_page'),
          }"
          mobile-breakpoint="0"
        >
          <template v-slot:item.dthr_aceite_termo="{ item }">
            {{ formatDateTime(item.dthr_aceite_termo) || "-" }}
          </template>
          <template v-slot:item.cupom="{ item }">
            {{ item.cupom || "-" }}
          </template>
          <template v-slot:item.link="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  :color="$config.dados.corinputs"
                  :disabled="!item.dthr_aceite_termo"
                  @click="copyLink(item)"
                  icon
                  small
                >
                  <v-icon>mdi-link-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("people.affiliates.copy-link") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { formatDateTime } from "../../utils";

export default {
  name: "AffiliateDetails",
  props: {
    affiliateId: {
      type: String,
      required: true,
    },
    affiliateSlug: {
      type: String,
    },
  },
  data() {
    return { formatDateTime };
  },
  computed: {
    ...mapGetters(["sale", "loadingSale"]),
    headers() {
      return [
        {
          text: this.$t("people.affiliates.network-name"),
          value: "nome_programa",
          align: "start",
          width: 180,
        },
        {
          text: this.$t("people.affiliates.accept-terms-date-hour"),
          value: "dthr_aceite_termo",
          align: "center",
          width: 240,
        },
        {
          text: this.$t("people.affiliates.coupon"),
          value: "cupom",
          align: "center",
          width: 140,
        },
        {
          text: this.$t("people.affiliates.link"),
          value: "link",
          align: "center",
          sortable: false,
          width: 120,
        },
      ];
    },
    programSales() {
      return this.sale.PROGRAMAS;
    },
  },
  methods: {
    ...mapActions(["fetchSaleByAffiliateId", "showSnackbarSuccess"]),
    ...mapMutations(["setSale"]),
    copyLink(item) {
      const environment = process.env.NODE_ENV;
      const slug = "afiliado/" + item.slug_programa + "/" + this.affiliateSlug;
      this.showSnackbarSuccess(
        this.$t("people.affiliates.link-copied-success")
      );
      switch (environment) {
        case "development":
          return navigator.clipboard.writeText(
            "https://dev.eleventickets.com/" + slug
          );
        case "homolog":
          return navigator.clipboard.writeText(
            "https://ah.eleventickets.com/" + slug
          );
        case "staging":
          return navigator.clipboard.writeText(
            "https://staging.eleventickets.com/" + slug
          );
        case "production":
          return navigator.clipboard.writeText(
            "https://eleventickets.com/" + slug
          );
      }
    },
  },
  mounted() {
    this.fetchSaleByAffiliateId({ id: this.affiliateId });
  },
  destroyed() {
    this.setSale([]);
  },
};
</script>

<style lang="scss" scoped>
.close-button {
  position: absolute;
  right: 24px;
}
</style>
